export const hasErrors = ({ field, form }) => {
  if (!form) return
  const { touched, errors, submitCount } = form
  if (
    (touched[field.name] && errors[field.name]) ||
    (submitCount > 0 && errors[field.name])
  ) {
    return true
  }
  return false
}

export { default as Label } from './Label'
export { default as Fieldset } from './Fieldset'
export { default as FormError } from './FormError'
export { default as RadioField } from './RadioField'
export { default as InputField } from './InputField'
export { default as FieldArrayInputField } from './FieldArrayInputField'
export { default as DateField } from './DateField'
export { default as DateTimeField } from './DateTimeField'
export { default as SelectField } from './SelectField'
export { default as ButtonGroup } from './ButtonGroup'
export { default as Button } from './Button'
export { default as TextAreaField } from './TextAreaField'
export { default as FieldArrayTextAreaField } from './FieldArrayTextAreaField'
export { default as CheckboxField } from './CheckboxField'
export { default as FileUploadInput } from './FileUploadInput'
export { default as SearchableSelect } from './SearchableSelect'
export { default as StoreFinderInput } from './StoreFinderInput'
export { default as HiddenField } from './HiddenField'
